import { Schema } from 'effect';

export const TimestampSchema = Schema.transform(Schema.String, Schema.String, {
  strict: true,
  decode: (timestamp) => (timestamp.endsWith('Z') ? timestamp : `${timestamp}Z`),
  encode: (timestamp) => (timestamp.endsWith('Z') ? timestamp.slice(0, -1) : timestamp)
});
